export default "__VITE_ASSET__83ad1729__"